import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { TutorsModule } from '../tutors/tutors.module';

import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';

import { LoginService } from './services/login.service';

@NgModule({

    declarations: [

        LoginComponent,
		RegisterComponent,
		ForgotPasswordComponent

    ],

    imports: [
        CommonModule,
        SharedModule,
        TutorsModule
    ],

    providers: [

        LoginService

    ]

})
export class AuthenticationModule { }
